module.exports = __webpack_public_path__ + "img/Ident-Process-6.3217e760.png";